import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container sub_page _news" }
const _hoisted_2 = { class: "sub_page_con wrap_1120" }
const _hoisted_3 = { class: "bread_crumbs" }
const _hoisted_4 = { class: "sub_page_con_view sign_form con_write" }
const _hoisted_5 = { class: "report_con" }
const _hoisted_6 = { class: "checkbox_wrap" }
const _hoisted_7 = { class: "file_wrap" }
const _hoisted_8 = { for: "area_file" }
const _hoisted_9 = { class: "file_list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "file_name" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "btn_wrap _default left_right_btn _1_2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_ModalPreviewForBoard = _resolveComponent("ModalPreviewForBoard")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _cache[21] || (_cache[21] = _createStaticVNode("<section class=\"sub_page_tit\" data-v-6b4b73a6><div class=\"deco_wrap\" data-v-6b4b73a6><i class=\"deco_02\" data-v-6b4b73a6><img src=\"img/news_left.png\" data-v-6b4b73a6></i><i class=\"deco_03 _xsmall spin3\" data-v-6b4b73a6><img src=\"img/b_icon_03.png\" data-v-6b4b73a6></i><i class=\"deco_04 _xxsmall blink_zoom1\" data-v-6b4b73a6><img src=\"img/b_icon_04.png\" data-v-6b4b73a6></i><i class=\"deco_05 _xxxsmall blink_blink1\" data-v-6b4b73a6><img src=\"img/b_icon_04.png\" data-v-6b4b73a6></i><i class=\"deco_06\" data-v-6b4b73a6><img src=\"img/line_circle.png\" data-v-6b4b73a6></i><i class=\"deco_07 _small spin_blink2\" data-v-6b4b73a6><img src=\"img/b_icon_01.png\" data-v-6b4b73a6></i><i class=\"deco_08 _xsmall blink_blink3\" data-v-6b4b73a6><img src=\"img/b_icon_04.png\" data-v-6b4b73a6></i><i class=\"deco_09 _xsmall blink2\" data-v-6b4b73a6><img src=\"img/b_icon_02.png\" data-v-6b4b73a6></i><i class=\"deco_character\" data-v-6b4b73a6><img src=\"img/news_icon.png\" data-v-6b4b73a6></i></div><div class=\"banner_wrap wrap_1120\" data-v-6b4b73a6><h2 data-v-6b4b73a6>감시소식</h2></div></section>", 1)),
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[7] || (_cache[7] = _createElementVNode("a", {
            href: "",
            class: "icon_wrap"
          }, [
            _createElementVNode("img", {
              src: "img/home_icon.png",
              alt: "홈"
            })
          ], -1)),
          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "icon_wrap" }, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: "감시소식"
            })
          ], -1)),
          _createVNode(_component_router_link, { to: "/news" }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("감시소식", -1)
            ]))]),
            _: 1
          }),
          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "icon_wrap" }, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: "글쓰기"
            })
          ], -1)),
          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "news_title" }, "글쓰기", -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_6, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "form_li_tit" }, "제목", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "제목을 입력해주세요.",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form_state.title) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form_state.title]
                ])
              ]),
              _cache[20] || (_cache[20] = _createElementVNode("li", { class: "" }, [
                _createElementVNode("span", { class: "form_li_tit" }, "내용"),
                _createElementVNode("textarea", {
                  id: "editor1",
                  name: "editor1"
                })
              ], -1)),
              _createElementVNode("li", _hoisted_7, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "form_li_tit" }, "첨부", -1)),
                _createElementVNode("label", _hoisted_8, [
                  _createElementVNode("input", {
                    id: "area_file",
                    type: "file",
                    placeholder: "",
                    accept: "image/*",
                    multiple: "",
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleFiles && $setup.handleFiles(...args)))
                  }, null, 32),
                  (!$setup.state.isMobile)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "file_box_wrap" }, "‘파일첨부’ 버튼을 클릭하여 첨부해주세요", -1)),
                        _cache[13] || (_cache[13] = _createElementVNode("span", {
                          class: "blue_btn",
                          style: {"display":"flex","justify-content":"center","align-items":"center"}
                        }, "파일첨부", -1)),
                        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "p_info" }, "200M 이하 JPG, PNG 파일을 첨부해주세요.", -1))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[15] || (_cache[15] = _createElementVNode("p", { class: "p_info" }, "200M 이하 JPG, PNG 파일을 첨부해주세요.", -1)),
                        _cache[16] || (_cache[16] = _createElementVNode("span", {
                          class: "blue_btn",
                          style: {"display":"flex","justify-content":"center","align-items":"center"}
                        }, "파일첨부", -1))
                      ], 64))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form_state.file, (item, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "file",
                      key: idx
                    }, [
                      _createElementVNode("span", {
                        class: "file_name",
                        onClick: ($event: any) => ($setup.downloadFile(item.file, item.imgRealName))
                      }, _toDisplayString(item.imgRealName), 9, _hoisted_10),
                      _createElementVNode("button", {
                        class: "file_del icon_wrap",
                        onClick: ($event: any) => ($setup.fileRemove(item.idx))
                      }, [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("img", {
                          src: "img/close_02.png",
                          alt: ""
                        }, null, -1)
                      ]))], 8, _hoisted_11)
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.file, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "file",
                      key: index
                    }, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(item.name), 1),
                      _createElementVNode("button", {
                        class: "file_del icon_wrap",
                        onClick: ($event: any) => ($setup.removeNewFile(index))
                      }, [...(_cache[18] || (_cache[18] = [
                        _createElementVNode("img", {
                          src: "img/close_02.png",
                          alt: ""
                        }, null, -1)
                      ]))], 8, _hoisted_13)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "common_btn _gray w_130",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.router.go(-1)))
          }, "취소"),
          (!$setup.state.isMobile)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "common_btn w_130",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.state.isShowPreview = true))
              }, "미리보기"))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "common_btn w_130",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.save && $setup.save(...args)))
          }, "작성완료")
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowPreview)
      ? (_openBlock(), _createBlock(_component_ModalPreviewForBoard, {
          key: 1,
          type: 'news',
          title: $setup.form_state.title,
          content: $setup.form_state.content,
          data: $setup.form_state,
          onClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.state.isShowPreview = false))
        }, null, 8, ["title", "content", "data"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ], 64))
}